module.exports = __webpack_public_path__ + "08ed5a178add3fb9edaedfe2d34e7f76.pdf";